import { combineReducers } from 'redux'

import getCareTasksList from './getCareTasksList'
import createCareTask from './createCareTask'
import updateCareTask from './updateCareTask'
import deleteCareTask from './deleteCareTask'
import ensureTasksRange from './ensureTasksRange'
import completeTasks from './completeTasks'

import { slice as getCareTasksListSlice } from './getCareTasksList'
import { slice as createCareTaskSlice } from './createCareTask'
import { slice as updateCareTaskSlice } from './updateCareTask'
import { slice as deleteCareTaskSlice } from './deleteCareTask'
import { slice as ensureTasksRangeSlice } from './ensureTasksRange'
import { slice as completeTasksSlice } from './completeTasks'

const careTasksRootReducer = combineReducers({
  ...getCareTasksList,
  ...createCareTask,
  ...updateCareTask,
  ...deleteCareTask,
  ...ensureTasksRange,
  ...completeTasks
})

export const careTaskSagas = [
  ...getCareTasksListSlice.sagas,
  ...createCareTaskSlice.sagas,
  ...updateCareTaskSlice.sagas,
  ...deleteCareTaskSlice.sagas,
  ...ensureTasksRangeSlice.sagas,
  ...completeTasksSlice.sagas
]

export default careTasksRootReducer
